<div class="row" *ngIf="isComercial">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                                floatLabel="{{ formFieldFloatLabel }}">
                                <mat-label class="InputLabelColor">Linha</mat-label>
                                <mat-select #txtHibrido formControlName="linha" disableCenteringOption>
                                    <mat-option *ngFor="let item of listLinha" [value]="item.name">{{ item.name |
                                        uppercase }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                                floatLabel="{{ formFieldFloatLabel }}">
                                <mat-label class="InputLabelColor">Peneira</mat-label>
                                <mat-select #txtHibrido formControlName="peneira" disableCenteringOption>
                                    <mat-option *ngFor="let item of listPeneira" [value]="item.name">{{ item.name |
                                        uppercase }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                                floatLabel="{{ formFieldFloatLabel }}">
                                <mat-label class="InputLabelColor">Tag Trieur</mat-label>
                                <mat-select #txtHibrido formControlName="tag_trieur" disableCenteringOption>
                                    <mat-option *ngFor="let item of listTagTrieur" [value]="item.name">{{ item.name |
                                        uppercase }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                                floatLabel="{{ formFieldFloatLabel }}">
                                <mat-label class="InputLabelColor">Camisa</mat-label>
                                <mat-select #txtHibrido formControlName="camisa" disableCenteringOption>
                                    <mat-option *ngFor="let item of listCamisa" [value]="item.name">{{ item.name |
                                        uppercase }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                                floatLabel="{{ formFieldFloatLabel }}">
                                <mat-label class="InputLabelColor">Fração Enviada para o Silo</mat-label>
                                <mat-select #txtHibrido formControlName="fracao_enviada_silo" disableCenteringOption>
                                    <mat-option *ngFor="let item of listFracaoEnviada" [value]="item.name">{{ item.name |
                                        uppercase }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>

                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>